import LoadSkeleton from "../../loadSkeleton";
import LoadErrorText from "../../loadErrorText";

const SelectItemWithLoad = ({ icon, children, options, errorMessage }) =>
  options ? (
    options !== "e" ? (
      children
    ) : (
      <LoadErrorText icon={icon} message={errorMessage} />
    )
  ) : (
    <LoadSkeleton size="small" />
  );

export default SelectItemWithLoad;
